import { render } from "./RelatorioProfissionais.vue?vue&type=template&id=90de0e84&scoped=true"
import script from "./RelatorioProfissionais.vue?vue&type=script&lang=js"
export * from "./RelatorioProfissionais.vue?vue&type=script&lang=js"

import "./RelatorioProfissionais.vue?vue&type=style&index=0&id=90de0e84&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90de0e84"]])

export default __exports__